import type { BroadcastI18nKey } from './keys';

// 中文文案：括号里的"排除"是产品语义保留，去掉会改变含义。
export const zh: Record<BroadcastI18nKey, string> = {
  // Tab
  BroadcastTabCompose: '群发消息',
  BroadcastTabSchedule: '定时列表',

  // Target
  BroadcastTargetModeLabel: '发送对象',
  BroadcastTargetSelected: '选择群+联系人',
  BroadcastTargetAllGroups: '所有群（排除）',
  BroadcastTargetAllContacts: '所有联系人（排除）',
  BroadcastTargetGroupMembers: '某个群的全部成员',
  BroadcastTargetAllChats: '所有联系人和群组',
  BroadcastTargetPhoneNumbers: '手机号码',
  BroadcastSelectedChatsLabel: '选择聊天',
  BroadcastExcludeLabel: '排除的聊天',
  BroadcastGroupSelectLabel: '选择群',
  BroadcastGroupSelectPlaceholder: '请选择群',
  BroadcastPhoneLabel: '手机号码（空格 / 换行 / 逗号分隔，最多 100 个）',
  BroadcastPhonePlaceholder: '例如：85259845194 8613800000000',
  BroadcastPhoneHint: '{count} / {max}',
  BroadcastBadgeContact: '联系人',
  BroadcastBadgeGroup: '群',

  // Content
  BroadcastContentTypeLabel: '消息类型',
  BroadcastContentText: '文本消息',
  BroadcastContentMedia: '媒体文件',
  BroadcastContentImageText: '图片+文本',
  BroadcastMessageLabel: '消息内容',
  BroadcastMessagePlaceholder: '输入要发送的文本...',
  BroadcastMediaLabel: '选择文件',
  BroadcastImageTextImageLabel: '选择图片',
  BroadcastImageTextMessageLabel: '图片下方文字',
  BroadcastImageTextMessagePlaceholder: '输入图片下方的文字内容...',

  // Interval & schedule
  BroadcastIntervalLabel: '发送间隔（秒）',
  BroadcastIntervalSep: '~',
  BroadcastScheduleLabel: '定时发送',
  BroadcastSilentLabel: '静默发送（不提醒）',

  // Progress
  BroadcastProgressLabel: '发送进度',
  BroadcastProgressDetail: '{current} / {total} ({percent}%) - 成功 {success}，失败 {fail}',

  // Buttons
  BroadcastBtnStart: '开始群发',
  BroadcastBtnStop: '停止发送',
  BroadcastBtnClose: '关闭',
  BroadcastBtnRefresh: '刷新列表',
  BroadcastBtnCancel: '取消',

  // Task list
  BroadcastTaskEmpty: '暂无定时任务',
  BroadcastTaskStatusPending: '等待中',
  BroadcastTaskStatusRunning: '发送中',
  BroadcastTaskStatusCompleted: '已完成',
  BroadcastTaskStatusCancelled: '已取消',
  BroadcastTaskScheduledTime: '计划时间: {time}',
  BroadcastTaskTargetWithCount: '目标: {mode} ({count}个)',
  BroadcastTaskTargetNoCount: '目标: {mode}',
  BroadcastTaskContent: '内容: [{type}] {preview}',
  BroadcastTaskProgress: '进度: {current} / {total}',
  BroadcastTaskTitle: '任务 #{id}',

  // Alerts
  BroadcastAlertPickChat: '请至少选择一个聊天',
  BroadcastAlertPickGroup: '请选择群',
  BroadcastAlertPickFile: '请选择文件',
  BroadcastAlertPickImage: '请选择图片',
  BroadcastAlertPickImageText: '请输入图片下方的文字内容',
  BroadcastAlertPickPhone: '请输入至少一个手机号码',
  BroadcastAlertPickMessage: '请输入消息内容',
  BroadcastAlertTimeMustFuture: '定时发送时间必须晚于当前时间',
  BroadcastScheduledCreated: '定时任务已创建！\n计划发送时间: {time}',
  BroadcastFinishedAllFail: '群发任务结束：全部 {fail} 条都失败，请查看控制台日志',
  BroadcastFinishedPartial: '群发任务结束：成功 {success}，失败 {fail}（请查看控制台）',
  BroadcastFinishedAllOk: '群发任务完成！成功 {success} 条',

  // Top-level
  BroadcastOpenPanelTitle: '打开群发面板',
  BroadcastMembersUnit: '成员',
};
